export {default as ErrorBoundary } from './ErrorBoundary.vue'

export default class ErrorsService {
    error = false;
    errorMessage = '';

    private static shared = new ErrorsService();

    public static get instance () {
        return this.shared;
    }

    constructor() {
        //console.log("[ErrorsService] Is constructed");
    }

    public onError(error: Error) {
        this.error = true;
        this.errorMessage = error.message;
    }
};
